require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-48-self-powers.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-48-self-powers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-48-self-powers!./.cache/json/coding-interview-prep-project-euler-problem-48-self-powers.json
// module id = 1779
// module chunks = 231608221292675